import { APP_BASE_HREF } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderComponent } from '@app/_core/components/header/header.component';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { SecurityService } from '@app/_core/services/security.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { UserService } from '@app/_core/services/user.service';
import { ConfigService } from '@app/config.services';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
import { WindowsWrapperService } from '@app/_core/services/windows-wrapper.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { DialerService } from '@app/_core/services/dialer.service';
import { environment } from 'src/environments/environment';
import { FlexibleStoreService } from '@app/_core/services/flexible-storage.service';

@Component({
  selector: 'app-task-menu',
  templateUrl: './task-menu.component.html',
  styleUrls: ['./task-menu.component.scss'],
})
export class TaskMenuComponent implements OnInit, OnDestroy {
  public event: EventEmitter<any> = new EventEmitter();
  @Output() taskmenuLoaded: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input()
  queueList: any;
  @Input()
  isAuditor: any = false;
  @Input()
  isManager: any = false;
  @Input()
  isStaffer: any = false;
  @Input()
  isReporter: any = false;
  @Input()
  isCloseable: any;
  @Input()
  isTM: any = false;
  @Input()
  isTwilio: any = false;

  hdrText: string = '';
  btnText: string = '';
  lists: any = [];
  companyCode: any = '';
  clientAbbreviation: any = '';
  QueueInfoDetail: any;
  selectedAccordion: String = 'Inbound'
  noQueues: string;
  taskMenuHeading: string;
  enableEmailQueue: boolean = environment.enableEmailQueue ?? false;
  taskMenuLoadedTimeout: any;
  pageRefreshedTimeout: any;
  constructor(
    private securityService: SecurityService,
    public bsModalRef: BsModalRef,
    private router: Router,
    private queueService: QueuesService,
    private appService: AppService,
    private headerComponent: HeaderComponent,
    private tmQueueService: TmQueueService,
    private configService: ConfigService,
    private mainController: MainControllerComponent,
    private userService: UserService,
    private OnvidaWrapper: WindowsWrapperService,
    private webStorageService: WebStorageService,
    private dailerService: DialerService,
    private flexStore: FlexibleStoreService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) { }

  ngOnInit() {
    //  console.log(this.isTwilio);
    let company = this.webStorageService.getItemFromSessionStorage('company');
    if(company == 'Baycare' || company == 'Parkland' || company == 'Antidote'){
       let cachedSCIData = JSON.parse(this.flexStore.get('sciData'));
      if (!cachedSCIData || cachedSCIData?.length === 0) {
        this.queueService.getSCIData();
      }
    }
    if (this.queueService.getTaskMenuAccordian().trim() !== '') {
      this.selectedAccordion = this.queueService.getTaskMenuAccordian();
    } else {
      var isBlendedAvailable = false;
      if (this.queueList.length > 0) {
        isBlendedAvailable = this.queueList.find(user => user.Type === 'Blended');
      }

      this.selectedAccordion = (isBlendedAvailable ? 'Blended' : 'Inbound')
    }
    //this.companyCode = localStorage.getItem("companyCode");
    this.clientAbbreviation = Utils.fetch('clientAbbreviation');
    this.renderConsoleAccess();
    this.appService.setUserStatus(18, null);
    //  console.log('queuelist',this.queueList);

    if (this.queueList.length === 0) {
      this.taskMenuHeading = 'Menu'
      this.noQueues = 'No Queues Assigned.\nPlease reach out to your team lead to request queue assignment.';
    }
    //  else if (this.queueList.length == 1) {
    //   console.log(this.queueList);
    //   this.goToQueue(JSON.parse());
    // }
    else {
      this.taskMenuHeading = 'Select a Task'
      this.renderView();
      //this.mainController.initializeSoftPhone();
    }


    this.taskMenuLoadedTimeout = setTimeout(() => {
      this.taskmenuLoaded.emit(true);
    }, 100);
    this.pageRefreshedTimeout = setTimeout(() => {
      if (localStorage.getItem('pageRefreshed') === 'true') {
        console.log('~~~~~~~Page was refreshed');
        // Add your logic here
        localStorage.removeItem('pageRefreshed');
        const selectedQueue = localStorage.getItem('selectedQueue');
        // console.log(selectedQueue)
        // localStorage.removeItem('selectedQueue');
        if (selectedQueue) {
          this.goToQueue(JSON.parse(selectedQueue));
        }
      }
      // else {
      //   this.taskmenuLoaded.emit(true);
      //   console.log('~~~~~~~Page was not refreshed');
      // }
    }, 300);
  }

  ngOnDestroy(): void {
    this.taskMenuLoadedTimeout && clearTimeout(this.taskMenuLoadedTimeout);
    this.pageRefreshedTimeout && clearTimeout(this.pageRefreshedTimeout);
  }

  renderConsoleAccess() {
    if (this.isTM && !(this.isAuditor || this.isManager || this.isStaffer)) {
      this.hdrText = '';
      this.btnText = '';
    } else if (this.isAuditor || this.isManager || this.isStaffer) {
      this.hdrText = (this.isManager || this.isStaffer ? 'Manager' : 'Auditor') + ' Console';

      this.btnText =
        ((this.isManager || this.isStaffer) && this.isAuditor
          ? 'Manage / Audit'
          : this.isManager || this.isStaffer
            ? 'Manage'
            : 'Audit') + ' Agents';

      /*
            
                var hRule = new im.CLView();
                hRule.width('100%').height(1).y(15).backgroundColor('#CCCCCC');
                cls.addSubView(hRule);
            
                var spacer = new im.CLView();
                spacer.width('100%').height(15);
                cls.addSubView(spacer);
            
                consoleBtn.addEventListener(im.UIMouseEvent.CLICK, function (e) {
                    currQueueID = null;
                    cls.dispatchEvent(im.QueueSelectorView.CONSOLE_BUTTON_CLICK);
                });
            
            consoleBtnDashboard.addEventListener(im.UIMouseEvent.CLICK, function (e) { 
              currQueueID = null;
              cls.dispatchEvent(im.QueueSelectorView.DASHBOARD_BUTTON_CLICK);
            });
            }
            }*/
    }
  }

  getHeadingContent(item: any, i: number) {
    return (
      '<h2 class="accordion-header" [id]="\'heading\'' +
      i +
      '"><button class="accordion-button" [ngClass]="{ \'collapsed\': ' +
      i +
      ' != 0 }" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="\'#collapse\'+' +
      i +
      '" [attr.aria-expanded]="' +
      i +
      ' == 0" [attr.aria-controls]="\'collapse\'+' +
      i +
      '"> <span class="menu-item">' +
      item.name +
      ' </span> <span class="count">' +
      item.totalrecords +
      '</span></button></h2>'
    );
  }

  renderView() {
    const currQueueID: any = '';
    let thisList: any = [];
    let finalList: any;
    for (let x = 0; x < this.queueList.length; x++) {
      const q = this.queueList[x];

      if (
        (q.Type == 'Inbound' || q.Type == 'VideoChat' || q.Type == 'TextChat') &&
        q.LinkedQueueCount > 0 &&
        q.HideIfBlended === true
      )
        continue;
      if (this.getFromArray(this.lists, q.Type, 'name') == null) {
        var hdrText;

        hdrText = q.Type.split(/(?=[A-Z])/).join(' ');

        this.lists.push({ name: q.Type, data: [] });

        thisList = this.getFromArray(this.lists, q.Type, 'name');
      } else {
        thisList = this.getFromArray(this.lists, q.Type, 'name');
      }
      let queueItem: any = [];
      let countLabel = null;
      switch (q.Type) {
        case 'Blended':
          var inboundCount = 0;
          for (const i in q.LinkedQueueIDs) {
            const linkedQ = this.getFromArray(this.queueList, q.LinkedQueueIDs[i], 'ID');
            if (linkedQ != null) inboundCount += linkedQ.Items;
          }
          //  countLabel = inboundCount + ' Waiting / ' + q.Items + ' Record' + ((q.Items == 1) ? '' : 's');
          countLabel = inboundCount + '/ ' + q.Items;
          break;
        case 'Inbound':
          countLabel = q.Items;
          break;
        case 'InboundFax':
          countLabel = q.Items;
          break;
        case 'TextChat':
        case 'VideoChat':
          countLabel = q.Items;
          break;
        case 'Outbound':
          countLabel = q.Items;
          break;
        case 'Email':
          countLabel = q.Items;
          break;
        default:
          break;
      }
      queueItem = {
        id: q.ID,
        type: q.Type,
        dialertype: q.DialerType,
        name: q.Name,
        items: q.Items,
        countLabel: countLabel,
        queue: q,
      };

      const index = this.getArrayIndex(this.lists, q.Type, 'name');

      this.lists[index].data.push(queueItem);
      this.lists[index].totalrecords = this.getTotalRecords(this.lists[index]);
    }
    // TODO: Remove once the API returns real Email queue data
    if (environment.enableEmailQueue && this.getFromArray(this.lists, 'Email', 'name') == null) {
      this.lists.push({
        name: 'Email',
        data: [{
          id: '12',
          type: 'Email',
          dialertype: 'Email',
          name: 'Email Queue',
          items: 0,
          countLabel: 0,
          queue: { ActivityID: 7 }
        }],
        totalrecords: 0
      });
    }

    const sectionOrder = ['Blended', 'Inbound', 'Outbound', 'Search', 'Email'];
    this.lists.sort((a: any, b: any) => {
      const ai = sectionOrder.indexOf(a.name);
      const bi = sectionOrder.indexOf(b.name);
      return (ai === -1 ? sectionOrder.length : ai) - (bi === -1 ? sectionOrder.length : bi);
    });
  }

  getFromArray(array: any, search: any, propName: any) {
    const index = this.getArrayIndex(array, search, propName);
    if (index != -1) {
      return array[index];
    }
    return null;
  }

  getArrayIndex(array: any, search: any, propName: any) {
    for (let i = 0; i < array.length; i++) {
      if (propName != null) {
        if (array[i][propName] == search) {
          return i;
        }
      } else if (array[i] == search) {
        return i;
      }
    }
    return -1;
  }

  getTotalRecords(item: any) {
    let count = 0;
    for (let i = 0; i < item.data.length; i++) {
      count = count + item.data[i].items;
    }
    return count;
  }

  goToQueue(selectedQueue: any) {
    
    localStorage.removeItem('queueSearchVal');
    // this.event.emit({selectedQueue});
    localStorage.removeItem('_pl');
    this.queueService.setQueueRoute('');
    this.queueService.setisEscalatedCases(false);
    this.queueService.SetVoicemailDetailsReply(false);
    this.dailerService.setIsFreeDialer(false);
    this.queueService.setChildCallID(''); 
    this.queueService.setInteractionID('');
    this.mainController.setInteractionType(selectedQueue?.type);
    this.queueService.currentInteractionID(null);
    this.mainController.setIsCaseUserUnmapped(null);
    this.mainController.setIsUnknownContact(false);
    this.mainController.setUnmappedCaseID('');
    this.mainController.setUnmappedUserID('');
    this.mainController.setHideUnknownContact(false);
    this.mainController.setAllDialerWindowStatus(false, false, false);
    this.mainController.setDialerType(selectedQueue?.dialertype);
    localStorage.setItem('qid', selectedQueue?.id);
    localStorage.setItem('selectedQueue', JSON.stringify(selectedQueue));
    this.queueService.setselectedQueueId(selectedQueue?.id);
    if (selectedQueue?.dialertype == 'Keypad') {
      this.queueService.notifyOtherFromTaskMenu({
        refresh: true,
        menuName: 'Outbound',
      });
    }
    else {
      this.queueService.notifyOtherFromTaskMenu({
        refresh: true,
        menuName: (selectedQueue?.dialertype == 'Progressive' ? 'Inbound' : selectedQueue?.type),
      });
    }

    this.queueService.SetTaskSelectedQueue({
      refresh: true,
      menuName: selectedQueue,
    });
    this.queueService.setIsPageLoadCompleted(false);
    this.tmQueueService.setisBlendedQueue(selectedQueue?.type == 'Blended');
    //this.tmQueueService.setisCallConnected(false);
    this.queueService.setTaskMenuQueueSelected({
      pageRefresh: true,
      isPageInitCompleted: false,
      queueType: (selectedQueue?.dialertype == 'Progressive' ? 'Inbound' : selectedQueue?.type),
    });
    //  this.queueService.setTaskMenuQueueSelected(true);
    this.closeTaskSelectionMenu();
    // console.log('selectedQueue', selectedQueue);
    //this.router.navigateByUrl(this.clientAbbreviation + '/Queue/'+ selectedQueue.type +"?qid="+ selectedQueue.id );
    this.headerComponent.getInboundCallStats(selectedQueue?.id);
    this.appService.setselectedQueueId(selectedQueue?.id);
    this.appService.setSelectedQueueName(selectedQueue?.name);
    if (selectedQueue?.dialertype == 'Keypad') {
      this.appService.setSelectedQueueType('Outbound');
    }
    else {
      this.appService.setSelectedQueueType((selectedQueue?.dialertype == 'Progressive' ? 'Inbound' : selectedQueue?.type));
    }
    this.appService.setActivityId(selectedQueue?.queue.ActivityID);
    this.getQueueInfo(selectedQueue?.id);
    this.mainController.initializeSoftPhone();

    //let url = this.configService.geturl(this.clientAbbreviation);
    let url = this.webStorageService.getItemFromSessionStorage('loginParams')?.ExternalAPIURL;
    if (url) {
      if(this.OnvidaWrapper.IsWrapper() && (this.clientAbbreviation == 'BCH' || this.clientAbbreviation == 'PCH' ||this.clientAbbreviation == 'AHP')){
        url = 'cr' + url;
        this.OnvidaWrapper.EnableCRProtocol(true);
      }
     if(!this.appService.getHasOpenedQNX()  && selectedQueue?.type !== 'Inbound' &&
     selectedQueue?.type !== 'Outbound' && selectedQueue?.type !== 'Search' && selectedQueue?.type !== 'Email')
      {
     this.configService.OpenUrlInNewTab(url);
      }
      
    }

    //manual blended queue redirecting to outbound queue
    if (selectedQueue?.dialertype == "Manual" && selectedQueue?.type == 'Blended') {
      // this.appService.setSelectedQueueType('Outbound');
      this.queueService.setQueueRoute(
        this.clientAbbreviation + '/Queue/Outbound?qid=' + selectedQueue?.id
      );
        this.router.navigateByUrl(this.clientAbbreviation + '/Queue', { skipLocationChange: true }).then(() => {
        this.router.navigate([this.clientAbbreviation + '/Queue/Outbound'], {
          queryParams: { qid: selectedQueue?.id },
        });
      });
    }
    else if (selectedQueue?.dialertype != 'Progressive' && selectedQueue?.dialertype != 'Keypad') {
      this.queueService.setQueueRoute(
        this.clientAbbreviation + '/Queue/' + selectedQueue?.type + '?qid=' + selectedQueue?.id
      );
        this.router.navigateByUrl(this.clientAbbreviation + '/Queue', { skipLocationChange: true }).then(() => {
        // this.router.navigate([this.clientAbbreviation + '/Queue/' + selectedQueue.type]);
        this.router.navigate([this.clientAbbreviation + '/Queue/' + selectedQueue?.type], {
          queryParams: { qid: selectedQueue?.id },
        });
      });
    }
    else if (selectedQueue?.dialertype == 'Keypad') {
      //this.mainController.setisCaseDetail(true);
      this.queueService.setQueueRoute(
        this.clientAbbreviation + '/Queue/Outbound?qid=' + selectedQueue?.id
      );
      this.appService.setActionItemId(selectedQueue?.id + '-' + null + '-' + null);
        this.router.navigateByUrl(this.clientAbbreviation + '/Queue', { skipLocationChange: true }).then(() => {

        this.router.navigate([this.clientAbbreviation + '/Queue/caseDetails'], {
          queryParams: { qid: selectedQueue?.id },
        });
      });
    }
    else if (selectedQueue?.dialertype == 'Progressive') {
      this.queueService.setQueueRoute(
        this.clientAbbreviation + '/Queue/Inbound?qid=' + selectedQueue?.id
      );
        this.router.navigateByUrl(this.clientAbbreviation + '/Queue', { skipLocationChange: true }).then(() => {

        this.router.navigate([this.clientAbbreviation + '/Queue/Inbound'], {
          queryParams: { qid: selectedQueue?.id },
        });
      });
    }
    //else if (selectedQueue?.type == 'Blended' && selectedQueue?.dialertype != 'Progressive') {
    //    this.queueService.setQueueRoute(
    //        this.clientAbbreviation + '/Queue/Outbound?qid=' + selectedQueue?.id
    //    );
    //    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    //        // this.router.navigate([this.clientAbbreviation + '/Queue/' + selectedQueue.type]);
    //        this.router.navigate([this.clientAbbreviation + '/Queue/Outbound'], {
    //            queryParams: { qid: selectedQueue?.id },
    //        });
    //    });
    //}
    //else if (selectedQueue?.type == 'Blended' && selectedQueue?.dialertype == 'Progressive') {
    //    this.queueService.setQueueRoute(
    //        this.clientAbbreviation + '/Queue/Inbound?qid=' + selectedQueue?.id
    //    );
    //    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {

    //        this.router.navigate([this.clientAbbreviation + '/Queue/Inbound'], {
    //            queryParams: { qid: selectedQueue?.id },
    //        });
    //    });
    //}
    //this.router.navigate([this.clientAbbreviation + '/Queue/' + selectedQueue.type], {
    //  queryParams: { qid: selectedQueue.id },
    //});
      this.appService.adjustTimer();
      //if(this.webStorageService.getItemFromSessionStorage('previousUserStatus') !== 7)
          this.webStorageService.setItemInSessionStorage('previousUserStatus', 6);
  }

  closeTaskSelectionMenu() {
    this.bsModalRef.hide();
  }

  closeTaskSelection() {
    let status = this.webStorageService.getItemFromSessionStorage('previousUserStatus');

    this.appService.setUserStatus(status, null);
    this.bsModalRef.hide();
  }

  goToConsole() {
    //this.closeTaskSelectionMenu();
    //setTimeout(() => this.router.navigateByUrl('/' + this.clientAbbreviation + '/Console/Queues'), 0);
    //this.router.navigate([this.clientAbbreviation + '/Console/Queues']);
    this.mainController.setAllDialerWindowStatus(false, false, false);
    this.queueService.setQueueRoute(this.clientAbbreviation + '/Console/Queues');
    this.appService.setUserStatus(12, null);
    this.webStorageService.setItemInSessionStorage('previousUserStatus', 12)
    this.closeTaskSelectionMenu();

    let url = this.clientAbbreviation + '/Console/Queues';
    let currMenu = {
      listmenu: this.clientAbbreviation + '/Console',
      menu: 'Queues',
      submenu: '',
      name: 'Queues',
      action: url,
    };

    let consoleChildren = JSON.parse(sessionStorage.getItem('consoleChildren') || '[]');
    let hasQueueAccess = consoleChildren.filter((menu: any) => menu.label === 'Queues').length > 0;

    if (!hasQueueAccess) {
      url = this.clientAbbreviation + '/Console';
      currMenu = {
        listmenu: this.clientAbbreviation + '/Console',
        menu: 'Agents',
        submenu: 'LiveStatuses',
        name: 'LiveStatuses',
        action: url
      };
    }

    this.appService.setCurrentMenu(currMenu);
    this.router.navigate([url]);
    this.headerComponent.changeUserStatusHeader();
    this.mainController.initializeSoftPhone();
  }
  getQueueInfo(queueId: any) {
    this.tmQueueService.getQueueInfo(queueId).subscribe(data => {
      // console.log("getQueueInfo response", data);

      this.QueueInfoDetail = data.Response.Data;
      this.mainController.setQueueInfoDetail(data.Response.Data);
      this.appService.SetQueueInfo(this.QueueInfoDetail);
    });
  }

  goToDashboard() {
    let reportingURL = this.webStorageService.getItemFromSessionStorage('loginParams');
    if(reportingURL && reportingURL.DashboardURL){
      window.open(reportingURL.DashboardURL);
    }    
  }

  logout() {
    this.tmQueueService.setUserStatus(2, null).subscribe((result: any) => {
      this.appService.setCurrentMenu(null);
      Utils.store('clientAbbreviation', null);
      this.securityService.clientAbbr = null;
      this.securityService.setUserData(null);
      this.userService.logout();
    });
  }
}
